import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const RefreshAnswer = ({ text }) => (
  <span className={cx("refresh-answer")}>{text}</span>
);

RefreshAnswer.propTypes = {
  text: PropTypes.string,
};

export default RefreshAnswer;
